import React, { useState, useEffect } from "react";
import { Card, Tooltip, Button } from "antd";
import Modal from 'react-modal';
import { EyeOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import laptop from "../../images/laptop.png";
import { Link } from "react-router-dom";
import { showAverage } from "../../functions/rating";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { getProduct, productStar, getRelated, } from "../../functions/product";
import OMF from "../../images/OMF.jpg";
import { addToWishlist } from "../../functions/user";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import IncrementQuantity from "./IncrementQuantity";
import { getAllSuperCoupon, clipCouponUser, fulfillCouponUser, removeFulfillCouponUser, getSpecificCoupon } from "../../functions/superCoupon";
import { message } from 'antd';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { PixelAddToCart } from "../../functions/facebookEvent";
import { currencyFormatter, currencyFormatterWithMultiplier } from "../../Utils/helper";

const { Meta } = Card;

const ProductCard = ({ product, filterDone, changes }) => {

  const { images, title, description, slug, price, MRP, brand, ShelfLife, category, weight, dealPrice, _id } = product;

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [currency, setCurrency] = useState("INR");
  const [currencyMultiplier, setCurrencyMultiplier] = useState(1); // Default multiplier


  // const loadSingleProduct = () => {
  //   getProduct(slug).then((res) => {
  //     setProduct(res.data);
  //     // load related
  //     getRelated(res.data._id).then((res) => setRelated(res.data));
  //   });
  // };
  let history = useHistory();

  const [count, setCount] = useState(0)

  const [superCoupons, setSuperCoupons] = useState({})
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    let arr = []
    for (let i = 0; i < cart.length; i++) {
      arr.push(cart[i]._id)
    }
    if (arr.indexOf(product._id) > -1 == true) {
      setShowResults(false)
    } else {
      setShowResults(true)
    }

  }, []);
  useEffect(() => {
    let arr = []
    for (let i = 0; i < cart.length; i++) {
      arr.push(cart[i]._id)
    }
    if (arr.indexOf(product._id) > -1 == true) {
      setShowResults(false)
    } else {
      setShowResults(true)

    }

  }, [filterDone]);



  const changesDone = () => {
    console.log('changed');

  }

  useEffect(() => {
    if (_id) {
      // loadSuperCoupons()
    }
  }, [_id]);

  useEffect(() => {
    // Retrieve currency and multiplier from localStorage
    const storedCurrency = localStorage.getItem("currency") || "USD";
    const storedMultiplier = parseFloat(localStorage.getItem("currencyMultiplier")) || 1;    
    setCurrency(storedCurrency);
    setCurrencyMultiplier(storedMultiplier);
  }, [localStorage.getItem("currencyMultiplier")]);

  const loadSuperCoupons = async () => {
    setLoading(true)
    setSuperCoupons([])
    let cart = [];
    if (slug) {
      getSpecificCoupon(slug).then((res) => {
        if (res.data == true) {
          getAllSuperCoupon().then((c) => {
            for (let i = 0; i < c.data.length; i++) {
              c.data[i].product.map((u) => {
                if (u == _id) {
                  setSuperCoupons(c.data[i])
                  if (user && c.data[i].product && _id && c.data[i].product.indexOf(_id) > -1 == true && c.data[i].usersFulfilled.indexOf(user._id) > -1 == true) {
                    if (localStorage.getItem("cart")) {
                      cart = JSON.parse(localStorage.getItem("cart"));
                    }
                    cart.map((products, t) => {
                      if (products._id == _id) {
                        if (c.data[i].type == 'each') {
                          cart[t].price = c.data[i].offer
                        } else if (c.data[i].type == 'save') {
                          cart[t].price = product.price - c.data[i].offer
                        }
                      } else {
                        setLoading(false)
                      }
                    })
                    setLoading(false)
                    localStorage.setItem("cart", JSON.stringify(cart));
                    dispatch({
                      type: "ADD_TO_CART",
                      payload: cart,
                    });
                  }
                } else {
                  setLoading(false)
                }

              })
            }
          });
        } else {
          setLoading(false)
        }
      })
    }

  }




  const [isModalVisible, setIsModalVisible] = useState(false);

  const [products, setProducts] = useState([]);
  const [related, setRelated] = useState([]);
  const [showResults, setShowResults] = useState(true)


  const [tooltip, setTooltip] = useState("Click to add");

  // redux
  const { user, cart, cartBtn, superCoupon } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  // const newValue = user.filter( (user)=> user._id === product._id);

  const handleHide = () => {
    setShowResults(true)
  };

  const changeButton = () => (
    <>
      {cart.filter(t => t._id === product._id).map((p) => (
        <IncrementQuantity key={p._id} p={p} handleHide={handleHide} superCoupons={superCoupons} original={product} loadSuperCoupons={loadSuperCoupons} />
      ))}
    </>
  );

  const normalButton = () => (
    <>
      <button onClick={handleAddToCart} className="button button--add-to-cart"> Add to Cart </button>
    </>
  )

  const refreshPage = () => {
    window.location.reload();
  }

  useEffect(() => {
    if (cartBtn == true) {
      handleAddToCart()
    }
  }, [cartBtn]);

  const handleCheckAddToCart = () => {
    cart.map((i) => {
      if (product._id != i._id) {
        handleAddToCart()
      } else {
        toast.success()
      }
    });
  }

  useEffect(() => {
    if (superCoupon == true && _id && user && superCoupons.product && superCoupons.product.indexOf(_id) > -1 == true && superCoupons.usersClipped.indexOf(user.id)) {
      // loadSuperCoupons()
      dispatch({
        type: "SET_SUPER_COUPON_VISIBLE",
        payload: false,
      });
    }
  }, [superCoupon])

  const handleAddToCart = () => {
    // create cart array
    PixelAddToCart(product)
    let cart = [];
    let quan = [];
    if (typeof window !== "undefined") {
      // if cart is in local storage GET it
      if (localStorage.getItem("cart")) {
        cart = JSON.parse(localStorage.getItem("cart"));
      }

      cart.map((product, i) => {
        if (product.superCouponApplied == superCoupons._id) {
          quan.push(product.count)
        }
      })
      const finalValue = (quan.reduce((a, v) => a = a + v, 0));

      // push new product to cart
      if (user && superCoupons.product && _id && superCoupons.product.indexOf(_id) > -1 == true && superCoupons.usersClipped.indexOf(user.id) == true && superCoupons.quantity == 1) {
        if (superCoupons.type == 'each') {
          cart.push({
            ...product,
            count: 1,
            // price: superCoupons.offer,
            superCouponApplied: superCoupons._id
          });
          fulfillCouponUser(superCoupons._id, user._id, user.token).then((res) => {
            message.success("Coupon Fulfilled!");
            dispatch({
              type: "SET_SUPER_COUPON_VISIBLE",
              payload: true,
            });
          });
        } else if (superCoupons.type == 'save') {
          cart.push({
            ...product,
            count: 1,
            // price: product.price - superCoupons.offer,
            superCouponApplied: superCoupons._id
          });
          fulfillCouponUser(superCoupons._id, user._id, user.token).then((res) => {
            message.success("Coupon Fulfilled!");
            dispatch({
              type: "SET_SUPER_COUPON_VISIBLE",
              payload: true,
            });
          });
        }
      } else if (user && superCoupons.product && _id && superCoupons.product.indexOf(_id) > -1 == true) {
        cart.push({
          ...product,
          count: 1,
          superCouponApplied: superCoupons._id,
        });

        if (superCoupons.usersClipped.indexOf(user._id) > -1 == true && superCoupons.quantity == finalValue + 1) {
          fulfillCouponUser(superCoupons._id, user._id, user.token).then((res) => {
            message.success("Coupon Fulfilled!");
            dispatch({
              type: "SET_SUPER_COUPON_VISIBLE",
              payload: true,
            });

          });
        }
      } else {
        cart.push({
          ...product,
          count: 1,
        });
      }

      // remove duplicates
      let unique = _.uniqWith(cart, _.isEqual);
      // save to local storage
      // console.log('unique', unique)
      let pp = cart.filter((ele, ind) => ind === cart.findIndex(elem => ele.title === elem.title))

      localStorage.setItem("cart", JSON.stringify(pp));
      // show tooltip
      setTooltip("Added");

      // add to reeux state
      dispatch({
        type: "ADD_TO_CART",
        payload: pp,
      });
      // show cart items in side drawer
      dispatch({
        type: "SET_VISIBLE",
        payload: true,
      });
      // console.log(cart.includes);
      setShowResults(false)
    }
  };

  const handleCartItems = () => {

  };

  const handleAddToWishlist = (e) => {
    e.preventDefault();
    addToWishlist(product._id, user.token).then((res) => {
      toast.success("Added to Shopping List");
    });
  };

  const handleAddToWishlistUser = () => {
    toast.error("Please Sign in to make Shopping List");
  };

  const handleClipped = async (e) => {
    e.preventDefault()
    let quan = []
    let cart = []
    if (user) {
      await clipCouponUser(superCoupons._id, user._id, user.token).then(async (res) => {
        if (localStorage.getItem("cart")) {
          cart = JSON.parse(localStorage.getItem("cart"));
        }
        cart.map((product, i) => {
          if (product.superCouponApplied == superCoupons._id) {
            quan.push(product.count)
          }
        })
        const finalValue = (quan.reduce((a, v) => a = a + v, 0));
        if (superCoupons.quantity <= finalValue) {
          await fulfillCouponUser(superCoupons._id, user._id, user.token).then((res) => {
            message.success("Coupon Clipped & Fulfilled!");
            dispatch({
              type: "SET_SUPER_COUPON_VISIBLE",
              payload: true,
            });
          });
        } else {
          message.success("Coupon Clipped!");
          dispatch({
            type: "SET_SUPER_COUPON_VISIBLE",
            payload: true,
          });
        }
      });
    } else {
      toast.error('Please Sign in to Clip Coupons')
    }
  }

  const calculateTimeLeft = (dealDate) => {
    const difference = +new Date(dealDate) - +new Date();

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (product.dealDate) {
        // Force component to re-render every second
        setCount((prevCount) => prevCount + 1);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, product.dealDate]);

  const formatTimeLeft = (timeLeft) => {
    let formattedTime = '';
    if (timeLeft.hours !== undefined) {
      formattedTime += `${String(timeLeft.hours).padStart(2, '0')}:`;
    }
    if (timeLeft.minutes !== undefined) {
      formattedTime += `${String(timeLeft.minutes).padStart(2, '0')}:`;
    }
    if (timeLeft.seconds !== undefined) {
      formattedTime += String(timeLeft.seconds).padStart(2, '0');
    }
    return formattedTime;
  };

  // destructure
  return (
    <>
      {/* {product && product.ratings && product.ratings.length > 0 ? (
        showAverage(product)
      ) : (
          <div className="text-center pt-1 pb-3">No Ratings Yet</div>
        )} */}

      <li key={product._id} className="tile product-cell product-grid-cell tile" content="[object Object]">
        <div className="product-tile_content">
          <div>
            <div className="flag_outer-container">
              {dealPrice && (
                <span className="flag_label flag_label--water"> Deal of the Day</span>
              )}
              {price < MRP && (
                <span className="flag_label flag_label--tomato"> Sale
                  {' '}
                  {(100 - (Math.round((price / MRP) * 100))) > 5 && (
                    <>
                      {100 - (Math.round((price / MRP) * 100))}%
                    </>
                  )}
                </span>)}
            </div>
          </div>
          <div className="product-grid-cell_price-tag product-grid-cell_price-tag--full-tile">
            <Link to={`/product/${slug}`}>
              <div className="product-image-container" style={{ position: 'relative' }}>
                <img src={images && images.length ? images[0].url : laptop} alt={title} className="product-grid-image product-grid-cell_main-image" />
                {product.dealDate && product.dealDate !== null && (
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    padding: '2px', // Smaller padding
                    textAlign: 'center',
                    fontSize: '8px', // Smaller font size
                  }}>
                    Deal Ends in {formatTimeLeft(calculateTimeLeft(product.dealDate))}
                  </div>
                )}
              </div>              <div className="product-tile_detail">
                <div className="skeleton-loader_wrapper">
                  {dealPrice ? (
                    <>
                      <div className="product-grid-cell_price-container product-grid-cell_price-container_column">
                        <span role="link" className="product-grid-cell_main-price product-grid-cell_main-price--on-sale-deal mr-2" > {currencyFormatterWithMultiplier(price, currencyMultiplier, currency)} </span>
                        <div className="product-grid-cell_was-container"><span className="product-grid-cell_regular-price product-grid-cell_regular-price--small"> {currencyFormatterWithMultiplier(MRP, currencyMultiplier, currency)} </span></div>
                      </div>
                    </>
                  ) : (
                    <>
                      {price < MRP ? (
                        <div className="product-grid-cell_price-container product-grid-cell_price-container_column"><span role="link" className="product-grid-cell_main-price product-grid-cell_main-price--on-sale"> {currencyFormatterWithMultiplier(price, currencyMultiplier, currency)} </span>
                          <div className="product-grid-cell_was-container"><span className="product-grid-cell_regular-price product-grid-cell_regular-price--small"> {currencyFormatterWithMultiplier(MRP, currencyMultiplier, currency)} </span></div>
                        </div>
                      ) : (
                        <div className="product-grid-cell_price-container">
                          <h3 className="product-grid-cell_main-price"> {currencyFormatterWithMultiplier(price, currencyMultiplier, currency)} </h3>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="product-tile_detail-title">
                <div className="skeleton-loader_wrapper">
                  <div data-v-12a9e0ca role="link" tabIndex={0} className="product-grid-cell_name">

                    <h3 className="product-grid-cell_name-text product-grid-cell_name-text--small product-grid-cell_name-text--clamp-2"  >
                      {brand.name == 'OPTIMA' ? (
                        <span data-v-12a9e0ca className="vector-icon_inline-text--left">
                          <div data-v-12a9e0ca className="vector-icon-size--xsmall">
                            <img src={OMF} alt="optima" />
                          </div>
                        </span>
                      ) : (
                        <></>
                      )}
                      <span className="item-tile_brand" style={{ textTransform: 'capitalize' }}>{title}</span>

                    </h3>
                  </div>
                </div>
                <div className="skeleton-loader_wrapper">
                  <div role="link" className="item-tile_description">
                    {weight && (
                      <>
                        <span className="item-tile_description"> {weight} </span>
                        <span aria-hidden="true"> | </span>
                      </>
                    )}
                    <span className="item-tile_description" style={{ textTransform: 'capitalize' }}> {category && category.name} </span></div>
                </div>
              </div>
            </Link>
            <div className="product-grid-cell_promo-name" />
            {loading == true ? (
              <Spin indicator={antIcon} />
            ) : (
              <>
                {superCoupons.product && superCoupons.product.indexOf(_id) > -1 == true && (
                  <div className="product-grid-cell_promo-name">
                    {user && superCoupons.usersClipped.indexOf(user._id) > -1 == true ? (
                      <div tabIndex={0} role="link" aria-label="Open coupon details" className="product-tile_coupon-offer product-tile_coupon-offer--clipped">
                        <div className="product-tile_coupon-offer-display">
                          <div className="product-tile_coupon-offer-name flex-center product-tile_coupon-offer-name--full-tile"><span>
                            {superCoupons.usersFulfilled.indexOf(user._id) > -1 == true && (
                              <div className="vector-icon_inline-check vector-icon-size--medium"><svg xmlns="http://www.w3.org/2000/svg" aria-label="PdlIconSuccessInverse" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className="vector-icon-fill--coupon vector-icon-stroke--white">
                                <title lang="en">PdlIconSuccessInverse</title>
                                <desc />
                                <g>
                                  <path d="M16,5.4C10.2,5.4,5.4,10.2,5.4,16c0,5.8,4.7,10.6,10.6,10.6S26.6,21.8,26.6,16C26.6,10.2,21.8,5.4,16,5.4z M21.7,13.9 l-6.9,6.9c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-3.4-3.4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l2.7,2.7l6.2-6.2 c0.4-0.4,1-0.4,1.4,0S22,13.6,21.7,13.9z">
                                  </path>
                                </g>
                              </svg></div>

                            )}
                          </span>
                            {superCoupons.type == 'each' ? (<>₹{superCoupons.offer} EACH/{superCoupons.quantity}</>) : (<>SAVE ₹{superCoupons.offer}/{superCoupons.quantity}</>)}
                          </div>
                        </div>
                        <div className="product-tile_coupon-offer_clipped-indicator">
                          <div className="vector-icon_inline vector-icon-size--no-margin vector-icon-size--xsmall"><svg xmlns="http://www.w3.org/2000/svg" aria-label="PdlIconCheckmark" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false"
                            className="vector-icon-stroke--dark-grey">
                            <title lang="en">PdlIconCheckmark</title>
                            <desc />
                            <g>
                              <path fill="none" strokeWidth={3} d="M28.279 7.467l-16.993 16.993-7.553-7.553" />
                            </g>
                          </svg></div>{superCoupons.usersFulfilled.indexOf(user._id) > -1 == true ? <>Coupon Fulfilled</> : <>Coupon Applied</>} </div>
                        <div className="product-tile_coupon-offer-loading-coupon"></div>
                      </div>
                    ) : (
                      <div onClick={handleClipped} tabIndex="0" role="link" aria-label="Open coupon details" className="product-tile_coupon-offer product-tile_coupon-offer-clippable">
                        <div className="product-tile_coupon-offer-display">
                          <div className="vector-icon-size--xsmall margin-right--half"><svg xmlns="http://www.w3.org/2000/svg" aria-label="PdlIconCouponScissor" viewBox="0 0 19 20" role="presentation" aria-hidden="true" focusable="false"
                            className="vector-icon-stroke--coupon">
                            <title lang="en">PdlIconCouponScissor</title>
                            <desc></desc>
                            <g>
                              <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                <g transform="translate(-13.000000, -12.000000)" stroke="#007DA3" strokeWidth="2">
                                  <g transform="translate(7.000000, 7.000000)">
                                    <path
                                      d="M15.6220981,14.6221481 L12.4444,11.44445 C11.19895,12.6902 9.17945,12.6902 7.93395,11.4447 C6.68845,10.1987 6.68845,8.1797 7.93395,6.9342 C9.17945,5.6887 11.19895,5.6887 12.44445,6.9342 C13.6899167,8.17966667 13.68995,10.198592 12.44455,11.4446 L15.6220981,14.6221481 L23.3104,6.9342 L15.6220981,14.6221481 Z M15.6220981,14.6221481 L23.3104,22.31045 L15.6220981,14.6221481 L12.4444,17.7997 L15.6220981,14.6221481 Z M7.9342,17.79995 C9.1797,16.55445 11.1987,16.55445 12.4447,17.79995 C13.6902,19.04545 13.6902,21.06495 12.4447,22.31045 C11.1987,23.55595 9.1797,23.55595 7.9342,22.31045 C6.6887,21.06495 6.6887,19.04545 7.9342,17.79995 Z">
                                    </path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg></div>
                          <div className="product-tile_coupon-offer-name flex-center product-tile_coupon-offer-name--full-tile">
                            <span></span>
                            {superCoupons.type == 'each' ? (
                              <>
                                ₹{superCoupons.offer} Each when you buy {superCoupons.quantity}
                              </>
                            ) : (
                              <>Save ₹{superCoupons.offer} when you buy {superCoupons.quantity} </>
                            )}


                          </div>
                        </div>
                        <div className="product-tile_coupon-offer-loading-coupon"></div>
                      </div>
                    )}

                  </div>
                )}
              </>)}





            <div className="margin-top--one">

              <div className="pdl-add-to-cart">
                <div className="pdl-add-to-cart_button">
                  {(localStorage.getItem("DeliveryType") == 'Shipping') ? (
                    <>
                      {product.quantity[0] < 1 && product.quantity[1] < 1 ? (
                        <>
                          <button className="out-of-stock_button button button--fourth button--with-subtext loading"> Out of Stock </button>
                        </>
                      ) : (
                        <>
                          {dealPrice ? (
                            <>
                              {showResults ? <button onClick={handleAddToCart} className="button button--add-to-cart-deal"> Add Deal to Cart </button> : <>{changeButton()}</>}
                            </>
                          ) : (
                            <>
                              {showResults == true ? <> {normalButton()}</> : <>{changeButton()}</>}
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {product.quantity[0] < 1 ? (
                        <>
                          <button className="out-of-stock_button button button--fourth button--with-subtext loading"> Out of Stock </button>
                        </>
                      ) : (
                        <>
                          {dealPrice ? (
                            <>
                              {showResults ? <button onClick={handleAddToCart} className="button button--add-to-cart-deal"> Add Deal to Cart </button> : <>{changeButton()}</>}
                            </>
                          ) : (
                            <>
                              {showResults == true ? <> {normalButton()}</> : <>{changeButton()}</>}
                            </>
                          )}
                          {/* <button onClick={handleAddToCart} className="button button--add-to-cart"> Add to Cart </button> */}
                        </>
                      )}
                    </>
                  )}


                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product-tile_action-items">
          <div className="shopping-list-menu_container">
            <div className="relative-el">
              {user ? (
                <button
                  onClick={handleAddToWishlist} aria-label="add to shopping list" className="button pdl-product-detail_top-icon button--fourth pdl-product-detail_top-icon--borderless">
                  <div className="vector-icon-size--large"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Shopping List Icon Add" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className="vector-icon-color--dark-grey">
                    <title lang="en">Shopping List Icon Add</title>
                    <desc />
                    <g>
                      <path d="M21.94066,15.3368884 L21.94066,12.8931995 C21.94066,12.3409148 22.3883752,11.8931995 22.94066,11.8931995 C23.4929447,11.8931995 23.94066,12.3409148 23.94066,12.8931995 L23.94066,15.3368884 L26.2522624,15.3368884 C26.8045471,15.3368884 27.2522624,15.7846037 27.2522624,16.3368884 C27.2522624,16.8891732 26.8045471,17.3368884 26.2522624,17.3368884 L23.94066,17.3368884 L23.94066,19.8787952 C23.94066,20.43108 23.4929447,20.8787952 22.94066,20.8787952 C22.3883752,20.8787952 21.94066,20.43108 21.94066,19.8787952 L21.94066,17.3368884 L19.2666667,17.3368884 C18.7143819,17.3368884 18.2666667,16.8891732 18.2666667,16.3368884 C18.2666667,15.7846037 18.7143819,15.3368884 19.2666667,15.3368884 L21.94066,15.3368884 Z M8,12 C7.44771525,12 7,11.5522847 7,11 C7,10.4477153 7.44771525,10 8,10 L19.1153581,10 C19.6676429,10 20.1153581,10.4477153 20.1153581,11 C20.1153581,11.5522847 19.6676429,12 19.1153581,12 L8,12 Z M8,17.3368884 C7.44771525,17.3368884 7,16.8891732 7,16.3368884 C7,15.7846037 7.44771525,15.3368884 8,15.3368884 L14.7200696,15.3368884 C15.2723543,15.3368884 15.7200696,15.7846037 15.7200696,16.3368884 C15.7200696,16.8891732 15.2723543,17.3368884 14.7200696,17.3368884 L8,17.3368884 Z M8,23 C7.44771525,23 7,22.5522847 7,22 C7,21.4477153 7.44771525,21 8,21 L19.1153581,21 C19.6676429,21 20.1153581,21.4477153 20.1153581,22 C20.1153581,22.5522847 19.6676429,23 19.1153581,23 L8,23 Z" fill="#000000" fillRule="nonzero" />
                    </g>
                  </svg></div>
                  <div className="pdl-product-detail_list-tooltip">
                    <p>Add item to Rashan List</p><em />
                  </div>
                </button>
              ) : (
                <button
                  onClick={handleAddToWishlistUser} aria-label="add to shopping list" className="button pdl-product-detail_top-icon button--fourth pdl-product-detail_top-icon--borderless">
                  <div className="vector-icon-size--large"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Shopping List Icon Add" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className="vector-icon-color--dark-grey">
                    <title lang="en">Shopping List Icon Add</title>
                    <desc />
                    <g>
                      <path d="M21.94066,15.3368884 L21.94066,12.8931995 C21.94066,12.3409148 22.3883752,11.8931995 22.94066,11.8931995 C23.4929447,11.8931995 23.94066,12.3409148 23.94066,12.8931995 L23.94066,15.3368884 L26.2522624,15.3368884 C26.8045471,15.3368884 27.2522624,15.7846037 27.2522624,16.3368884 C27.2522624,16.8891732 26.8045471,17.3368884 26.2522624,17.3368884 L23.94066,17.3368884 L23.94066,19.8787952 C23.94066,20.43108 23.4929447,20.8787952 22.94066,20.8787952 C22.3883752,20.8787952 21.94066,20.43108 21.94066,19.8787952 L21.94066,17.3368884 L19.2666667,17.3368884 C18.7143819,17.3368884 18.2666667,16.8891732 18.2666667,16.3368884 C18.2666667,15.7846037 18.7143819,15.3368884 19.2666667,15.3368884 L21.94066,15.3368884 Z M8,12 C7.44771525,12 7,11.5522847 7,11 C7,10.4477153 7.44771525,10 8,10 L19.1153581,10 C19.6676429,10 20.1153581,10.4477153 20.1153581,11 C20.1153581,11.5522847 19.6676429,12 19.1153581,12 L8,12 Z M8,17.3368884 C7.44771525,17.3368884 7,16.8891732 7,16.3368884 C7,15.7846037 7.44771525,15.3368884 8,15.3368884 L14.7200696,15.3368884 C15.2723543,15.3368884 15.7200696,15.7846037 15.7200696,16.3368884 C15.7200696,16.8891732 15.2723543,17.3368884 14.7200696,17.3368884 L8,17.3368884 Z M8,23 C7.44771525,23 7,22.5522847 7,22 C7,21.4477153 7.44771525,21 8,21 L19.1153581,21 C19.6676429,21 20.1153581,21.4477153 20.1153581,22 C20.1153581,22.5522847 19.6676429,23 19.1153581,23 L8,23 Z" fill="#000000" fillRule="nonzero" />
                    </g>
                  </svg></div>
                  <div className="pdl-product-detail_list-tooltip">
                    <p>Add item to Rashan List</p><em />
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>
      </li>
 
    </>
  );
};

export default ProductCard;
